export const meta = {
  id: 'A00',
  slug: 'comece-aqui',
  title: 'Bem-vindo ao Personagrama',
  description: 'Entenda como seu desenvolvimento acontece no Personagrama e por onde começar.',
  profile: 'student',
  category: 'comece-aqui',
  type: 'getting-started',
  status: 'published',
  order: 10,
  keywords: ['começar', 'primeiro acesso', 'aluno', 'desenvolvimento', 'personagrama'],
  next: 'G02',
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Bem-vindo ao Personagrama

O Personagrama acompanha seu desenvolvimento de forma contínua. A ideia não é apenas consumir conteúdo, mas transformar aprendizado em ação, evidência, acompanhamento e evolução.

Seu percurso pode envolver:

**Diagnóstico → Desenvolvimento → Plano → Jornada → Formação → Aprendizado → Prática → Evidências → Mentoria → Evolução.**

<Diagram kind="personagrama-flow" caption="O percurso não é uma linha rígida: cada etapa ajuda a orientar a próxima ação e sustentar a evolução contínua." />

## Por onde começar

<Steps>
  <Step title="Faça seu primeiro acesso">
    Ative seu acesso pelo convite recebido e entre na plataforma.
  </Step>
  <Step title="Consulte Hoje">
    A tela Hoje mostra o que merece sua atenção naquele momento.
  </Step>
  <Step title="Realize seu diagnóstico">
    Quando solicitado, use o diagnóstico como ponto de partida para identificar competências prioritárias.
  </Step>
  <Step title="Continue seu percurso">
    Avance pelo Desenvolvimento, Plano, Jornada, Formações, Treinamentos, Evidências e Mentorias conforme forem liberados para você.
  </Step>
</Steps>

<Callout type="tip">
  Sempre que tiver dúvida sobre o que fazer em seguida, volte para **Hoje**.
</Callout>

## O que você vai encontrar neste Centro de Ajuda

Os artigos explicam três coisas em conjunto: **o que você está fazendo, por que isso importa e qual é o próximo passo**.

Você também poderá buscar dúvidas com frases simples, como “como faço meu diagnóstico?” ou “por que minha formação está bloqueada?”.
